import { getSnowplowEventPayload, logAnalyticsEvent } from 'Services/analytics/analytics';
import { ANALYTICS_CATEGORIES, SNOWPLOW_EVENTS } from 'Services/analytics/analytics.const';

const { ACCOUNT } = ANALYTICS_CATEGORIES;
const { CLICK } = SNOWPLOW_EVENTS;

interface TriggerSellerMessagingSelectSellerCheckboxClickedEventParams {
	enquiryId: string;
	isChecked: boolean;
}

export const triggerSellerMessagingSelectSellerCheckboxClickedEvent = ({
	enquiryId,
	isChecked,
}: TriggerSellerMessagingSelectSellerCheckboxClickedEventParams): void => {
	const label = JSON.stringify({ [isChecked ? 'checked' : 'unchecked']: enquiryId });

	const eventPayload = getSnowplowEventPayload({
		category: ACCOUNT.SELLER_MESSAGING,
		customData: { label },
		name: 'dlr_seller_messaging_select_seller_checkbox_clicked',
		schemaName: CLICK.SCHEMA,
		version: CLICK.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};
